import { OperationModels } from '../../../kernel/base-entities'
import { Metadata } from './hela'
import { JobItem } from './items'
import { CartonizationPackageConstraints, PackageState, PackageTransferState } from './job-nebula'
import { Task } from './task'

export interface Job {
  id?: number
  uuid: string
  cityId?: number
  clientId?: number
  jobNumber: string
  receiver: Receiver
  origin: Location
  destination: Location
  operationModel: OperationModels
  status: JobState
  paymentMethod: string
  shippingFee?: number
  declaredValue?: number
  logisticCostAmount?: number
  logisticCostCurrency?: string
  timestamp?: string
  createdAt: string
  updatedAt: string
  issueOf?: any
  deliveryCode?: string
  deliveryCodeTriesLimit?: number
  deliveryCodeTries?: number
  invoices?: invoice
  paymentValue?: number
  paymentDetail?: string | null
  paymentReference?: string | null
  paymentMethodReference?: any
  paymentSucceeded?: boolean
  updatedPrices?: {
    discounts: number
    paymentValue: number
    shippingFee: number
    subtotal: number
    taxes: number
  }
  reference?: string
  jobComment?: string
  deliveryOptions?: any[]
  storeId?: string
  storeReference?: string
  packages?: Package[]
  partialStatus?: string
  storeTimezone?: string
  paymentInfo?: any
  finishedAt?: any
  slotFrom?: string
  slotTo?: string
  storeTzCreatedAt: string
  storeTzUpdatedAt: string
  storeTzSlotFrom?: string
  storeTzSlotTo?: string
  itemsStatusCount?: any
  externalData?: any
  deliveryValidations?: any
  pickUpCode?: string | null
  tasks?: Task[]
  priority?: number
  lastFlag?: any
  agents?: any[]
  isBigOrder: boolean
  source?: string
  items?: JobItem[]
  previousSlot?: {
    storeTzSlotFrom: string
    storeTzSlotTo: string
  } | null
  itemsUnitCount?: ItemsCount
}

export interface ItemsCount {
  added: number
  pending: number
  rejected: number
  removed: number
  total: number
}

export interface DeliveryCodeInfo {
  deliveryCode: string
  deliveryCodeTries: number
  deliveryCodeTriesLimit: number
}

export interface Location {
  city: string
  name: string
  address: string
  description: string
  state?: string
  country?: string
  zipCode?: string
  latitude?: number
  longitude?: number
  addressTwo?: string
}

interface invoice {
  value: number
  photosUrl: string[]
  billingNumber: string
}

interface Package {
  id: string
  job_id: string
  store_id: string
  reference: string | null
  zone: string | null
  state: PackageState
  transfer_state: PackageTransferState
  was_updated: boolean
  name: string | null
  department: string | null
  cartonization_constraints: CartonizationPackageConstraints | null
}

export interface Slots {
  express?: Slot[]
  static?: Slot[]
}

export type Slot = SlotV1 | SlotV2

export interface SlotV2 {
  id: string
  operationalModel: string
  from: string
  to: string
}

export interface SlotV1 {
  id: undefined
  operationalModel: undefined
  from: string
  to: string
}

export interface Receiver {
  email: string
  firstName: string
  identification: string | null
  lastName: string
  phoneNumber: string
  wantsToReceiveNotifications?: boolean
}

export interface ReponseGetJobsMap {
  jobs: Job[]
  metadata: Metadata
}

export enum JobState {
  CANCELLED = 'CANCELLED',
  PROCESSING = 'PROCESSING',
  CREATED = 'CREATED',
  FINISHED = 'FINISHED'
}

export type ResponseCustomFields = Pick<Job, 'id' | 'uuid' | 'priority' | 'lastFlag' | 'agents'>
